<template>
    <a :class="{'deal-box-wrapper': !isGiftList}" @click="goToDeal()" :href="dealLink" target="_blank" ref="dealbox">
        <div class="deal-box-giftlist" v-if="isGiftList">
            <div class="deal-box-number">#{{index + 1}}</div>
            <div class="deal-box-giftlist-img-container">
                <div v-if="!isDealVisible" class="blur-box shimmer"></div>
                <img v-if="isDealVisible" :src="deal.ImgUrl" :alt="deal.title">
            </div>
            <div class="deal-box-giftlist-text-container">
                <div class="deal-box-giftlist-title">{{deal.Title}}</div>
                <div class="deal-box-giftlist-desc">{{deal.Description}}</div>
                <div class="deal-box-giftlist-btn"><button>Check it Out</button></div>
            </div>
        </div>


        <div class="deal-box-img-container" v-if="!isGiftList">
            <a class="deal-image-soldout" v-if="deal.isSoldOut">
                <img src="/Assets/img/soldout.png" />
            </a>
            <div v-if="!isDealVisible" class="blur-box shimmer"></div>
            <img v-if="isDealVisible" class="deal-box-img" :src="deal.ImgUrl" :class="{'up-side-down': settings.purimMode}">
        </div>

        <div class="deal-box-desc" v-if="!isGiftList">
            {{deal.Title}}
            <span v-if="isSimpleView && deal.PromoCode">
                <br />
                <div class="share-link-container share-link-container-dealbox">
                    <input id="promoCode" v-model="deal.PromoCode" class="promo-code-input promo-code-input-dealbox" readonly />
                    <a v-show="!copied" class="promo-copy-code" @click="copyToClipboard($event)">COPY</a>
                    <a v-show="copied" class="promo-copy-code copied">COPIED</a>
                </div>

            </span>
        </div>

        <div class="deal-box-prices" v-if="showPrice" :class="{'hide-price': deal.DealPrice == '-1'}">
            <div class="crossed-price"><span v-if='deal.RetailPrice'>{{deal.RetailPrice | toCurrency(2)}}</span></div>
            <div class="deal-price">{{deal.DealPrice | toCurrency(2)}}</div>
        </div>
        <div class="deal-box-button-container" v-if="!isGiftList">
            <button class="button">Deal Details</button>
        </div>
        <div v-if="!isGiftList" class="logo-img-container">
            <img v-if="deal.DealProvider == 'Etsy'" class="amzn-img" alt="Etsy logo" src="/assets/img/logo-etsy.png">
            <span v-else-if="deal.DealProvider == 'BestBuy'"><img class="amzn-img" alt="BestBuy" src="/assets/img/bestbuy_logo2.png"></span>
            <img v-else-if="deal.DealProvider == 'Walmart'" class="amzn-img" alt="Etsy logo" src="/assets/img/walmart_logo.png">
            <img v-else-if="deal.DealProvider == 'Chewy'" class="amzn-img" alt="Chewy logo" src="/assets/img/chewy.png">
            <img v-else-if="deal.DealProvider == 'PatPat'" class="amzn-img" alt="PatPat logo" src="/assets/img/patpat_logo.png">
            <img v-else-if="deal.DealProvider == 'onlyonestopshop'" class="amzn-img" alt="only one stop shop" src="/assets/img/onlyonestopshop.gif">
            <img v-else-if="deal.DealProvider == 'Kohls'" class="logo-img" alt="Kohls logo" src="/assets/img/logos/kohls.png">
            <img v-else-if="deal.DealProvider == 'Groupon'" class="logo-img" alt="Groupon logo" src="/assets/img/logos/groupon.png">
            <img v-else-if="deal.DealProvider == 'OldNavy'" class="logo-img" alt="Old Navy logo" src="/assets/img/logos/oldnavy.png">
            <img v-else-if="deal.DealProvider == 'Zappos'" class="logo-img" alt="Zappos logo" src="/assets/img/logos/zappos.png">
            <img v-else-if="deal.DealProvider == 'Petco'" class="logo-img" alt="Petco logo" src="/assets/img/logos/petco.png">
            <img v-else-if="deal.DealProvider == 'PetSmart'" class="logo-img" alt="PetSmart logo" src="/assets/img/logos/petsmart.png">
            <img v-else-if="deal.DealProvider == 'Zulily'" class="logo-img" alt="Zulily logo" src="/assets/img/logos/zulily.png">

            <img v-else class="amzn-img" alt="Amazon logo" src="/assets/img/amazon-logo-640.png">
        </div>
    </a>
</template>

<script>

    import util from '@/helpers/util'
    import settings from '@/settings'
    import ga from '@/helpers/ga'
    import clicky from '@/helpers/clicky'

    export default {
        name: 'DealBox',
        props: ['deal', 'index'],
        data() {
            return {
                dealLink: null,
                showTitle: true,
                showDescription: false,
                showPrice: true,
                isGiftList: false,
                isSimpleView: false,
                copied: false,
                isDealVisible: false
            }
        },
        methods: {
            trackOutboundLink: function (url) {
                ga.event('click', { 'event_category': 'outbound', 'event_label': url, 'transport_type': 'beacon' });
                clicky.goal('GiftClick')
            },
            goToDeal() {

                if (this.isGiftList) {
                    console.log('YESSSS')
                    this.trackOutboundLink(this.dealLink);
                }


                //if (this.isSimpleView && this.deal.PromoCode) {
                //    if (this.$refs.promoCode) {
                //        var copyText = this.$refs.promoCode;
                //        console.log('copyText', copyText);
                //        copyText.select();
                //        document.execCommand("copy");
                //    }
                //}

                //window.open(this.deal.DealURL, "_blank");
            },
            copyToClipboard(event) {
                event.preventDefault();
                event.stopPropagation();
                var copyText = document.getElementById("promoCode");
                copyText.select();
                document.execCommand("copy");
                this.copied = true;
                setTimeout(() => {
                    this.copied = false;
                }, 2000);
            }
        },
        created() {



            let cookie_lastref = this.$cookie.get("MMD_LastRef");
            if (settings.siteName == 'fivetowncentral' || (cookie_lastref && cookie_lastref.toLowerCase() == '5townscentral')) {
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'tag', '5townscentral-20');
            }
            else if (settings.siteName == '5tcdeals') {
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'tag', '5townscentral-20');
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'sharedid', '5tcdeals');
            }
            else if (settings.siteName == 'momazon' || (cookie_lastref && cookie_lastref.toLowerCase() == 'adir')) {
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'tag', 'adirdeals-20');
            }
            else if (settings.siteName == 'alyssagoldwater' || (cookie_lastref && cookie_lastref.toLowerCase() == 'alyssagoldwater')) {
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'tag', 'agoldwater-20');
            }
            else if (cookie_lastref && cookie_lastref.toLowerCase() == 'mmdfriedman') {
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'tag', 'mmdfriedman-20');
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'sharedid', 'moshe');
            }
            else if (cookie_lastref && cookie_lastref.toLowerCase() == 'klugman') {
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'tag', '18ventures-20');
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'sharedid', 'klugman');
            }
            else if (cookie_lastref && cookie_lastref.toLowerCase() == 'dovidklugman') {
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'tag', 'mmdbraum-20');
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'sharedid', 'dovidklugman');
            }
            else if (cookie_lastref && cookie_lastref.toLowerCase() == 'braum') {
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'tag', 'mmdbraum-20');
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'sharedid', 'braum');
            }
            else if (cookie_lastref && cookie_lastref.toLowerCase() == 'tempelberg') {
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'tag', 'tempelberg-20');
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'sharedid', 'tempelberg');
            }
            else if (settings.siteName == 'mommydeals' && this.deal.DealProvider == 'Amazon') {
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'tag', 'mommydeals0a-20');
            }
            else if (settings.siteName == 'mommydeals' && this.deal.DealProvider == 'Walmart') {
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'sharedid', 'mommydeals');
            }
            else if (settings.siteName == 'petpetdeals' && this.deal.DealProvider == 'Amazon') {
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'tag', 'petpetdeals-20');
            }
            else if (settings.siteName == 'petpetdeals' && this.deal.DealProvider == 'Walmart') {
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'sharedid', 'petpetdeals');
            }
            else if (settings.siteName == 'chaideals' && this.deal.DealProvider == 'Amazon') {
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'tag', 'chaideals-20');
            }
            else if (settings.siteName == 'chaideals' && this.deal.DealProvider == 'Walmart') {
                this.deal.DealURL = util.replaceOrAddUrlParam(this.deal.DealURL, 'sharedid', 'chaideals');
            }

            if (this.$route.name == 'giftideas' || this.$route.name == 'giftlist' || this.$route.name == 'giftlist2') {
                this.isGiftList = true;
                this.showPrice = false;
                this.dealLink = this.deal.DealURL;
            }
            else {
                this.showPrice = true;
                this.isGiftList = false;

                if (this.$route.query.direct) {
                    this.isSimpleView = true;
                    this.dealLink = this.deal.DealURL;
                }
                else {
                    this.isSimpleView = false;
                    this.dealLink = '/Deal/' + this.deal.DealID + '/' + this.deal.PrettyTitle;
                }
            }

        },
        mounted() {
            util.doSomethingOnceVisible(this.$refs.dealbox, () => { this.isDealVisible = true; });
        },
        computed: {
            settings: function () { return settings; }
        },
    }
</script>
